module.exports = __webpack_public_path__ + "media/images/portfolio_upload-0ad92304122fba3ac60477eac0e46cc5.svg";